@if (design4) {
  <ng-container [ngTemplateOutlet]="DESIGN_4"></ng-container>
} @else {
  <ng-container [ngTemplateOutlet]="DESIGN_2"></ng-container>
}
<ng-template #DESIGN_2>
  <div class="item" fxLayout="row" fxLayoutGap="25px" fxLayoutGap.lt-md="5px" [ngClass]="{ disabled }">
    <div class="image" fxFlex="50px" fxLayoutAlign="space-around start">
      <img class="{{ icon }}" src="{{ 'assets/icons-v2/' + icon + '.svg' }}" [alt]="itemTitle" />
    </div>
    <div class="title" (click)="openInfoDialog()">
      <h3>
        {{ itemTitle }}
      </h3>
      <p>{{ subtitle }}</p>
      @if (key === 'small' && charitiesWithHighlightedUberSection.includes(charity?.id)) {
        <div class="uber" fxLayout="column" fxLayoutGap="6px">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="6px">
              Up to 5 bags/boxes - FREE pickup with
              <img class="uber-logo" src="assets/images/uber_logo.jpg" alt="Uber" />
            </span>
          </div>
        </div>
        <div class="fus-note" fxLayout="row">
          <span>*</span>
          <span>Qualifying donations to be subsidized by {{ charity?.name }}. Tips go directly to the driver.</span>
        </div>
      }
    </div>
    <div class="counter-controls" fxLayout="row" fxLayoutAlign="space-between">
      <div class="counter-btn" [ngClass]="{ disabled: count === 0 || count === min }" (click)="removeItem()">
        <mat-icon>remove</mat-icon>
      </div>
      @if (!editable || disabled) {
        <span [ngClass]="{ zero: count === 0 }">{{ count }}</span>
      }
      @if (editable && !disabled) {
        <input type="tel" [(ngModel)]="count" (keyup)="updateItem($event)" (focus)="focusInput($event)" />
      }
      <div class="counter-btn" [ngClass]="{ disabled: count === max }" (click)="addItem()">
        <mat-icon>add</mat-icon>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #DESIGN_4>
  <div class="item" fxLayout="row" fxLayoutGap="25px" fxLayoutGap.lt-md="5px" fxLayoutAlign="center center" [ngClass]="{ disabled }">
    <div class="image no-mobile" fxFlex="50px" fxLayoutAlign="space-around center">
      <img class="{{ icon }}" src="{{ 'assets/icons-v2/' + icon + '.svg' }}" [alt]="itemTitle" />
    </div>
    <div class="title" (click)="openInfoDialog()" fxLayout="column" fxLayoutGap="4px">
      <h3>
        <img class="no-desktop info-icon" src="/assets/images/info.svg" />
        {{ itemTitle }}
      </h3>
      <p>{{ subtitle }}</p>
      <div fxLayout="row" fxLayoutGap="10px">
        <p class="description">{{ description }}</p>
        <span class="read-more">read more</span>
      </div>
    </div>
    <div class="counter-controls" fxLayout="row" fxLayoutAlign="space-between">
      <div class="counter-btn" [ngClass]="{ disabled: count === 0 || count === min }" (click)="removeItem()">
        <mat-icon>remove</mat-icon>
      </div>
      @if (!editable || disabled) {
        <span [ngClass]="{ zero: count === 0 }">{{ count }}</span>
      }
      @if (editable && !disabled) {
        <input type="tel" [(ngModel)]="count" (keyup)="updateItem($event)" (focus)="focusInput($event)" />
      }
      <div class="counter-btn" [ngClass]="{ disabled: count === max }" (click)="addItem()">
        <mat-icon>add</mat-icon>
      </div>
    </div>
  </div>
</ng-template>
